"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWrappedStats = void 0;
const core_1 = require("@zodios/core");
const zod_1 = require("zod");
exports.getWrappedStats = (0, core_1.makeEndpoint)({
    method: "get",
    path: "/app/wrapped/:year",
    alias: "getWrappedStats",
    parameters: [],
    // todo: in 2025 this type should be generic (like the UserWrapped model)
    response: zod_1.z.object({
        streakDays: zod_1.z.number(),
        learnedWords: zod_1.z.number(),
        conversationHours: zod_1.z.number(),
    }),
});
//# sourceMappingURL=getWrappedStats.js.map